import { AccountNavigationView } from '@playbooks/components/account/account-navigation-view';

const AccountDropDevelopers = ({ target, onPrev }) => (
	<AccountNavigationView
		title='Developers'
		target={target}
		onBack={onPrev}
		items={[
			{ icon: 'book-open', href: '/docs', label: 'Docs' },
			{ icon: 'square-terminal', href: '/cli', label: 'CLI' },
			{ icon: 'brain-circuit', href: '/docs/mcp/overview', label: 'MCP' },
			{ icon: 'globe', href: '/reference', label: 'API Reference' },
		]}
	/>
);
export { AccountDropDevelopers };
